import { Injectable } from '@angular/core';
import { AuthenticatorService } from '@aws-amplify/ui-angular';

@Injectable({
  providedIn: 'root'
})
export class CurrentUserService {
  
  constructor(public authenticator: AuthenticatorService) { }

  get groups() : string[] {
    return this.authenticator.user.getSignInUserSession().getAccessToken().decodePayload()['cognito:groups'] || []
  }

  get isAdmin() : boolean {
    return this.groups.includes('Administrator')
  }

  get isPresenter() : boolean {
    return this.groups.includes('Presenter')
  }

}
